const verticals = [{
    name: 'Digital',
    class: 'digital',
    options: ['Adobe Analytics', 'Google Analytics']
}, {
    name: 'Marketing',
    class: 'marketing',
    options: ['SAP Hybris', 'Marketo', 'Hubspot', 'Infusionsoft', 'Pardot']
}, {
    name: 'Sales',
    class: 'sales',
    options: ['Salesforce', 'Microsoft Dynamics', 'SugarCRM', 'Oracle', 'Siebel', 'In-house']
}, {
    name: 'Customer Support',
    class: 'support',
    options: ['SAP C4C', 'ServiceNow', 'Zendesk', 'RightNow', 'Service Cloud', 'Desk', 'In-house']
}, {
    name: 'Accounting',
    class: 'accounting',
    options: ['SAP', 'Workday', 'Quickbooks', 'Oracle', 'Netsuite', 'Peoplesoft', 'In-house']
}, {
    name: 'Email',
    class: 'email',
    options: ['Gmail', 'Outlook']
}, {
    name: 'Web Conference / Chat Systems',
    class: 'web',
    options: ['Skype', 'Live Chat', 'Office 365', 'Webex', 'GoTo Meeting', 'Zoom', 'Zopim', 'LivePerson']
}, {
    name: 'Phone Systems',
    class: 'phone',
    options: ['Avaya', 'Asterisk', 'Mitel', 'Cisco', 'Shoretel', 'Siemens', '8x8', 'Broadsoft', 'Genesys', 'Panasonic']
}, {
    name: 'Call Recording',
    class: 'recording',
    options: ['Nice', 'Verint', 'Oaisys']
}, {
    name: 'Mobile',
    class: 'mobile',
    options: ['Apple', 'Android']
}];

module.exports = {
    getAll() {
        return Promise.resolve(verticals);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/js/services/VerticalService.js
// module id = 101
// module chunks = 0